import { createContext } from 'react';

const AppContext = createContext({
    access_token: '',
    config: {},
    locations: {}
});
export default AppContext;